export default "__VITE_ASSET__DTcqgb$h__"